import axios from "axios";
import { io } from "socket.io-client";

export type IResponse<T> = {
    success: true;
    result: T
} | {
    success: false,
    error: string
};


let socket = io(process.env.REACT_APP_SOCKET_URL ?? "ws://localhost:5001/admin", {
    auth: {
        token: localStorage.getItem('admin_rezvan_token'),
    },
    autoConnect: false,
});
export default socket;

socket.on('connect', () => {
    console.log('connect');
    
})

socket.on("connect_error", (err) => {
    if (err.message === "User isn't login") {
        axios({
            url: `${process.env.REACT_APP_BASE_URL ?? 'http://localhost:5001/api/'}admin`,
            method: 'post',
        }).then(res => {
            if (res.data.success) {
                window.location.href = res.data.result;
            }
        }).catch(err => {
            console.log(err);
        })
    }
});
